import { useCallback } from "react";
import callApi from "../../../utility/apiCaller";

import {
  setInternalLead,
  setResponse,
  setAppId,
  setLeadId,
  setOpportunityId,
  setKycurl,
  setAmountRequired,
  setKfsUrl,
  setUserData,
  setEmendateUrl,
  setOpportunityName,

} from "../../../store/app/aaSlice"; // adjust import path
import { setOffers } from "../../../store/app/appReducer";

export default function useLeadInitializer(dispatch) {
  const initLead = useCallback(async (lead_Id) => {
    if (!lead_Id) return;

    const res = await callApi(
      "v1/lead/list",
      "post",
      {
        filters: { _id: lead_Id },
      },
      "core"
    );

    if (!res || res.status !== "Success") return;

    const list = res.data?.leadList || [];
    if (list.length === 0) return;

    const lead = list[0];

    const {
      _id = "",
      application_id = "",
      dmi_lead_response_id = "",
      dmi_lead_id = "",
      dmi_opportunityid = "",
      amount_required,
      kycurl = "",
      emandateurl = "",
      dmi_opportunityName = "",
      dmi_offers_details,
      kfsurl = "",
    } = lead;

    // --------------------------------
    // 🔥 SET ALL FIELDS IN STORE
    // -------------------------------
    dispatch(setInternalLead(_id));
    dispatch(setResponse(dmi_lead_response_id));
    dispatch(setAppId(application_id));
    dispatch(setLeadId(dmi_lead_id));
    dispatch(setOpportunityId(dmi_opportunityid));
    dispatch(setKycurl(kycurl));
    dispatch(setAmountRequired(amount_required));
    dispatch(setKfsUrl(kfsurl));
    dispatch(setUserData(lead));
    dispatch(setEmendateUrl(emandateurl));
    dispatch(setOpportunityName(dmi_opportunityName));
    dispatch(setOffers(dmi_offers_details));

    return lead;
  }, []);

  return initLead;
}
